import React, { useEffect, useState } from "react";
import { RevButton, RevProgress } from "../ds";
import { posterRatio } from "../../helpers/posterRatio";

/**
 * Vista previa del cartel tal cual lo pinta la galería pública: el cartel entero, sin
 * recorte. El marco adopta la proporción del cartel entre 3/4 y 4/3 (helpers/posterRatio);
 * arranca en 3/4 hasta que la imagen carga, y fuera del rango el hueco lo rellena su desenfoque. La usan Datos básicos (con la cruz
 * para quitarlo) y la pestaña Galería pública (solo lectura). Es el único componente que
 * escribe el marcado del cartel; su estilo vive en screens/evento-datos-basicos.css.
 *  - src: URL del cartel (firmada o data URL); sin src se pinta `emptyText`
 *  - loading: espera del cartel
 *  - caption: pie de la figura
 *  - onRemove / removeLabel: si se dan, la cruz para quitar el cartel
 */
const PosterPreview = ({ src, loading, alt, emptyText, caption, onRemove, removeLabel, ...rest }) => {
    const [ratio, setRatio] = useState(null);
    useEffect(() => { setRatio(null); }, [src]);
    // Imagen en caché: `onLoad` puede no llegar, así que la ref mide si ya está completa.
    const measure = image => { if (image?.complete && image.naturalWidth) setRatio(posterRatio(image.naturalWidth, image.naturalHeight)); };

    return (
    <figure className="rev-poster" {...rest}>
        <div className="rev-poster__marco" data-ratio={ratio ?? undefined} style={{ aspectRatio: ratio ? String(ratio) : '3 / 4' }}> {/* ds-lint: inline-ok */}
            {loading ? (
                <RevProgress />
            ) : src ? (
                <>
                    <img className="rev-poster__fondo" src={src} alt="" aria-hidden="true" />
                    <img className="rev-poster__img" src={src} alt={alt} ref={measure} onLoad={e => measure(e.currentTarget)} />
                    {onRemove && (
                        <RevButton className="rev-poster__quitar" variant="secondary" icon
                            aria-label={removeLabel} title={removeLabel}
                            onClick={e => { e.preventDefault(); onRemove(); }}>
                            <span className="material-icons">close</span>
                        </RevButton>
                    )}
                </>
            ) : (
                <p className="rev-poster__vacio">{emptyText}</p>
            )}
        </div>
        {caption && <figcaption className="rev-poster__pie">{caption}</figcaption>}
    </figure>
    );
};

export default PosterPreview;
